import { httpRequest } from "../../http";
import { CatalogUsage } from "@models/catalog.model";

// One item at a time: the server populates only that key and skips the whole-vertical scan.
export type UsageOnly = { metric_id?: number; dimension_id?: number; entity_type_id?: number };

export class CommandGetCatalogUsage {
  // What renaming each metric / dimension / entity type in a vertical would break (MPN-1781).
  async run(verticalCode: string, only?: UsageOnly): Promise<CatalogUsage> {
    const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/verticals/${encodeURIComponent(verticalCode)}/usage/`;
    const entry = only && Object.entries(only).find(([, v]) => v != null);
    const url = entry ? `${base}?${entry[0]}=${entry[1]}` : base;
    return httpRequest<CatalogUsage>(url, { method: "GET" });
  }
}
